import React, { useEffect, useState } from 'react';
import {
  Table,
  Button,
  Form,
  Input,
  Select,
  DatePicker,
  Popconfirm,
  Space,
  Card,
} from 'antd';
import {
  PlusOutlined,
  DeleteOutlined,
  InfoCircleOutlined,
} from '@ant-design/icons';
import { BiSolidShow } from 'react-icons/bi';
import { ModalAppTaxesDetails } from '../ModalApp/ModalApp';
const TaxtList = ({ t, form, loadingTaxesDetails, data, show }) => {
  const [selectData, setSelectData] = useState({});
  const [open, setOpen] = useState(false);
  const dataSource = data || [];
  // const [dataSource, setDataSource] = useState([]);

  const columns = [
    {
      title: t.Category,
      dataIndex: 'category',
    },
    {
      title: t.addDeductTax,
      dataIndex: 'add_deduct_tax',
    },
    {
      title: t.chargeType,
      dataIndex: 'charge_type',
    },
    {
      title: t.accountHead,
      dataIndex: 'account_head',
    },
    {
      title: t.costCenter,
      dataIndex: 'cost_center',
    },
    {
      title: t.Rate,
      dataIndex: 'rate',
    },
    {
      title: t.Total,
      dataIndex: 'total',
    },
    {
      title: t.action,
      key: 'action',
      render: (text, record, index) => (
        <Space>
          <Button
            type="primary"
            // icon={<MdEdit />}
            icon={<BiSolidShow />}
            size="small"
            onClick={() => handleDetails(record.key)}
          />
          {/* <Popconfirm
            title={t.confirmDelete}
            onConfirm={() => handleDelete(record.key)}
          >
            <Button
              type="primary"
              danger
              icon={<DeleteOutlined />}
              size='small'
            />
          </Popconfirm> */}
        </Space>
      ),
    },
  ];

  // const handleAdd = () => {
  //   const newData = {
  //     key: count,
  //   };
  //   setDataSource([...dataSource, newData]);
  //   setCount(count + 1);
  // };

  // const handleDelete = (key) => {
  //   const newDataSource = dataSource.filter((item) => item.key !== key);
  //   setDataSource(newDataSource);
  // };

  const handleDetails = (key) => {
    const row = dataSource.find((item) => item.key === key);
    if (row) {
      setSelectData(row);
      setOpen(true);
      console.log('Row details:', row);
    }
  };

  return (
    <Card>
      <Table
        className="table_custom"
        dataSource={dataSource}
        columns={columns}
        pagination={{
          hideOnSinglePage: true,
        }}
        loading={loadingTaxesDetails}
        scroll={{ x: 'max-content' }}
        // className="table"
        rowKey="key"
      />
      {/* <Button
        onClick={handleAdd}
        type="primary"
        ghost
        style={{marginTop: '20px',borderRadius: '6px'}}
        icon={<PlusOutlined />}
        size='small'
      >
        {t.addRow}
      </Button> */}
      <ModalAppTaxesDetails
        t={t}
        open={open}
        setOpen={setOpen}
        selectData={selectData}
      />
    </Card>
  );
};

export default TaxtList;

// import { Button, Col, Flex, Form, Input } from 'antd';
// import React from 'react'
// import { MdDelete } from 'react-icons/md';
// import {PlusOutlined} from '@ant-design/icons';
// const TaxtList = ({t, form}) => {
//   return (
//     <div>
//                     <Col span={24} className="items-form-add">
//                   <Form.List name="taxes" style={{ width: '100%' }}>
//                     {(fields, { add, remove }) => (
//                       <>
//                         {fields?.map(({ key, name, ...restField }) => {
//                           // console.log(fields, 'restField');
//                           return (
//                             <Flex
//                             gap={5}
//                               justify="space-between"
//                               align="center"
//                               key={key}
//                               style={{
//                                 width: '100%',
//                               }}
//                               // align="baseline"
//                             >
//                               <Form.Item
//                                 name={[name, 'category']}
//                                 label={t.Category}
//                                 style={{
//                                   width: '100%',
//                                   marginBottom: '0px',
//                                 }}
//                                 {...restField}
//                               >
//                                 <Input  placeholder={t.Category} disabled />
//                               </Form.Item>
//                               <Form.Item
//                                 name={[name, 'add_deduct_tax']}
//                                 style={{
//                                   width: '100%',
//                                   marginBottom: '0px',
//                                 }}
//                                 {...restField}
//                                 label={t.addDeductTax}
//                               >
//                                 {
//                                   <Input
//                                     placeholder={t.addDeductTax}
//                                     style={{ width: '100%' }}
//                                     disabled
//                                   />
//                                 }
//                               </Form.Item>
//                               <Form.Item
//                                 name={[name, 'charge_type']}
//                                 style={{
//                                   width: '100%',
//                                   marginBottom: '0px',
//                                 }}
//                                 {...restField}
//                                 label={t.chargeType}
//                               >
//                                 <Input
//                                   placeholder={t.chargeType}
//                                   style={{ width: '100%' }}
//                                   disabled
//                                 />
//                               </Form.Item>
//                               <Form.Item
//                                 name={[name, 'account_head']}
//                                 style={{
//                                   width: '100%',
//                                   marginBottom: '0px',
//                                 }}
//                                 {...restField}
//                                 label={t.accountHead}
//                               >
//                                 <Input
//                                   placeholder={t.chargeType}
//                                   style={{ width: '100%' }}
//                                   disabled
//                                 />
//                               </Form.Item>
//                               <Form.Item
//                                 name={[name, 'description']}
//                                 style={{
//                                   width: '100%',
//                                   marginBottom: '0px',
//                                 }}
//                                 {...restField}
//                                 label={t.description}
//                               >
//                                 <Input
//                                   placeholder={t.description}
//                                   style={{ width: '100%' }}
//                                   disabled
//                                 />
//                               </Form.Item>
//                               <Form.Item
//                                 name={[name, 'rate']}
//                                 style={{
//                                   width: '100%',
//                                   marginBottom: '0px',
//                                 }}
//                                 {...restField}
//                                 label={t.rate}
//                               >
//                                 <Input
//                                   placeholder={t.rate}
//                                   style={{ width: '100%' }}
//                                   disabled
//                                 />
//                               </Form.Item>
//                               <Form.Item
//                                 name={[name, 'cost_center']}
//                                 style={{
//                                   width: '100%',
//                                   marginBottom: '0px',
//                                 }}
//                                 {...restField}
//                                 label={t.costCenter}
//                               >
//                                 <Input
//                                   placeholder={t.costCenter}
//                                   style={{ width: '100%' }}
//                                   disabled
//                                 />
//                               </Form.Item>
//                                 <div
//                                   style={{
//                                     display: 'flex',
//                                     justifyContent: 'center',
//                                     alignItems: 'center',
//                                     fontSize: '15px',
//                                     margin: '0 10px',
//                                   }}
//                                 >
//                                   <Button
//                                     type="text"
//                                     onClick={() => add()}
//                                     icon={<PlusOutlined color="#1890ff" />}
//                                   />
//                                   {fields.length > 1 && (
//                                     <Button
//                                       type="text"
//                                       onClick={() => remove(name)}
//                                       danger
//                                       icon={<MdDelete color="red" />}
//                                     />
//                                   )}

//                                 </div>
//                             </Flex>
//                           );
//                         })}
//                       </>
//                     )}
//                   </Form.List>
//                 </Col>
//     </div>
//   )
// }

// export default TaxtList
